
import { ItemCompact } from "@/models/ItemCompact";
import { Component, Prop, Vue } from "vue-property-decorator";

function escapePrintHtml(value: string) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function buildRecipeCategoryPrintDocument(categoryName: string, recipes: ItemCompact[] = []) {
  const safeCategoryName = escapePrintHtml(categoryName || "Recipe Category");
  const recipeItems = recipes
    .map((recipe) => `<li class="recipe-print">${escapePrintHtml(recipe.name)}</li>`)
    .join("");

  return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <title>${safeCategoryName}</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      color: #1f2933;
      margin: 0;
      background: #fff;
    }

    .recipe-category-printout {
      padding: 32px;
      background: #fff;
    }

    .category-header {
      margin-bottom: 32px;
      border-bottom: 1px solid #d9e2ec;
      padding-bottom: 12px;
    }

    .category-header h1 {
      margin: 0 0 12px;
      font-size: 28px;
      font-weight: 700;
    }

    .recipe-print-list {
      margin: 0;
      padding-left: 24px;
    }

    .recipe-print {
      margin-bottom: 10px;
      font-size: 16px;
      line-height: 1.5;
    }

    @media print {
      .recipe-category-printout {
        padding: 16mm;
      }
    }
  </style>
</head>
<body>
  <section class="recipe-category-printout">
    <header class="category-header">
      <h1>${safeCategoryName}</h1>
    </header>
    <ol class="recipe-print-list">${recipeItems}</ol>
  </section>
  <script>
    (function () {
      var hasClosed = false;
      function closeWindow() {
        if (hasClosed) {
          return;
        }
        hasClosed = true;
        window.close();
      }

      window.addEventListener("afterprint", function () {
        setTimeout(closeWindow, 0);
      });

      window.addEventListener("focus", function () {
        setTimeout(closeWindow, 300);
      }, { once: true });
    })();
  <\/script>
</body>
</html>`;
}

@Component
export default class vRecipeCategoryPrintout extends Vue {
  @Prop({ default: "" }) readonly categoryName!: string;
  @Prop({ default: (): ItemCompact[] => [] }) readonly recipes!: ItemCompact[];
}
